import { AppState, RedirectLoginOptions, useAuth0 } from '@auth0/auth0-react'
import { Browser } from '@capacitor/browser'

import React, { ReactNode } from 'react'

import { AUTH0_LOGIN_SCOPE, isNativeApp } from '../config/auth0'
import { AuthStateContext } from '../providers/AuthStateContext'

interface LoginButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  children?: ReactNode
}
export const LoginButton = (props: LoginButtonProps): JSX.Element => {
  const { children, onClick: onClickProp, ...rest } = props
  const isMobileDevice = isNativeApp()
  const { loginWithRedirect } = useAuth0()

  return (
    <button
      type="button"
      {...rest}
      onClick={(e) => {
        // separate redirectUrl like this since mobile devices don't get appState after redirect
        AuthStateContext.setRedirectUrl(window.location.pathname)

        let loginParams: RedirectLoginOptions<AppState> = {
          appState: { redirectUrl: window.location.pathname },
          authorizationParams: { scope: AUTH0_LOGIN_SCOPE },
        }
        if (isMobileDevice) {
          loginParams = {
            ...loginParams,
            async openUrl(url) {
              // Redirect using Capacitor's Browser plugin
              await Browser.open({
                url,
                windowName: '_self',
              })
            },
          }
        }
        loginWithRedirect(loginParams)
        onClickProp?.(e)
      }}
    >
      {children || 'Login'}
    </button>
  )
}
